<template>
	<job-list-item :job="props.position" :to="props.to" :title="props.position.user.display_name" :subtitle="props.position.title">
		<template #right>
			<chip v-if="position.is_accepted" color="success" class="mr-4 md:mr-16" x-small>{{ $t('label.confirmed') }}</chip>
			<chip v-else-if="position.is_invitation" color="warning" class="mr-4 md:mr-16" x-small>{{ $t('label.invite_pending') }}</chip>
			<chip v-else color="warning" class="mr-4 md:mr-16" x-small>{{ $t('label.request_pending') }}</chip>
		</template>
	</job-list-item>
</template>

<script setup lang="ts">
import type {Model} from "@spoferan/spoferan-ts-core";

const props = defineProps<{
	position: Model,
	to?: string | object,
}>();

</script>